import { endPointPrivate } from './config'
import axios from 'axios'

export default {
  pesquisarGrades: (termo) => {
    return axios.get(endPointPrivate + 'v1/grades?termo=' + termo)
  },
  detalheGrade: (param) => {
    return axios.get(endPointPrivate + 'v1/gradeProdutos?' + 'codigoGrade=' + param.codigoGrade + '&codProduto=' + param.codProduto + '&codigoTabelaPreco=' + param.codigoTabelaPreco)
  }
}



// WEBPACK FOOTER //
// ./src/services/produto.js